<div class="container-fluid mt-0">
  <div class="row">
    <iframe [src]="this.iframeSrc | safeUrl" title="{{this.companyName}} Test" class="p-0"></iframe>
  </div>
</div>